import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const AssetsWrapper = styled('div')`
    .dashboard-page.assets {
        padding-bottom: 80px;
        border-top: 0;
        margin-top: 0;

        .top-container {
            min-height: 120px;
        }

        .page-actions {
            margin-top: 167px;
        }
    }
`

export const TitleWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
`
